import { render, staticRenderFns } from "./PaperInfo.vue?vue&type=template&id=0009033a&scoped=true"
import script from "./PaperInfo.ts?vue&type=script&lang=ts&external"
export * from "./PaperInfo.ts?vue&type=script&lang=ts&external"
import style0 from "./PaperInfo.vue?vue&type=style&index=0&id=0009033a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0009033a",
  null
  
)

export default component.exports